import style from  "./ErrorMod.module.css";

import image from "../../data/img/error.png"
export default function ErrorMod({ idp }) {
    const homepage = `${window.location.origin}/acquisto_sms/?IDP=${idp}`
    
    return (
        <div className={style.wrapperMain}>

            <div className={style.content}>
                <h1 className={style.title}>Errore pagamento</h1>

                <p className={style.desc}>
                    Siamo spiacenti, il pagamento non è andato a buon fine.
                </p>

                <a href={homepage} className={style.Btn}>
                    Torna agli acquisti
                </a>
            </div>

            <img alt="errore pagamento" className={style.img} src={image} />
        </div>
    );
}